'use client'
const clientSessionKeyLogScope = 'client-session-key';

export { clientSessionKeyLogScope };
